import { useState } from 'preact/hooks';
import { putEvent } from '../api';
import { BrutalButton, BrutalInput } from "./BrutalUI";

interface AddSlotFormProps {
  slug: string;
  selectedDate: string;
  username: string;
  config: { month: number; year: number };
}

export default function AddSlotForm({
  slug,
  selectedDate,
  username,
  config,
}: AddSlotFormProps) {
  const [start, setStart] = useState('09:00');
  const [end, setEnd] = useState('10:00');
  const [desc, setDesc] = useState('');

  const submit = (e: Event) => {
    e.preventDefault();
    const slotId = Date.now();
    const message = `${username} added slot ${start}–${end} on ${selectedDate}`;
    putEvent(slug, {
      type: 'slot_created',
      message,
      data: {
        slot_id: slotId,
        user_id: 0,
        date: selectedDate,
        start_time: start,
        end_time: end,
        description: desc,
        creator_name: username,
      },
    }).then(() => setDesc(''));
  };

  return (
    <form
      onSubmit={submit}
      className="flex flex-wrap gap-4 items-end mb-5 p-4 bg-orange-50 dark:bg-gray-900 border-2 border-black dark:border-gray-100"
    >
      <BrutalInput
        type="time"
        value={start}
        onInput={(e) => setStart((e.target as HTMLInputElement).value)}
        className="text-base min-h-[2.75rem] min-w-[6rem]"
      />
      <BrutalInput
        type="time"
        value={end}
        onInput={(e) => setEnd((e.target as HTMLInputElement).value)}
        className="text-base min-h-[2.75rem] min-w-[6rem]"
      />
      <BrutalInput
        type="text"
        value={desc}
        onInput={(e) => setDesc((e.target as HTMLInputElement).value)}
        placeholder="Description"
        className="text-base min-h-[2.75rem] min-w-[14rem] flex-1"
      />
      <BrutalButton
        type="submit"
        variant="primary"
        className="px-5 py-2.5 text-base min-h-[2.75rem]"
      >
        Add slot
      </BrutalButton>
    </form>
  );
}
